export default class BancoHoraTransferencia {
    constructor() {
        this.id = null;     
        this.faixaSegunda = null;
        this.faixaTerca = null;
        this.faixaQuarta = null;
        this.faixaQuinta = null;
        this.faixaSexta = null;       
        this.faixaSabados = null;       
        this.faixaDomingos = null;              
        this.faixaFeriados = null;
        this.faixaFolgas = null;  
        this.fatorSegunda = null;
        this.fatorTerca = null;
        this.fatorQuarta = null;
        this.fatorQuinta = null;
        this.fatorSexta = null;
        this.fatorSabados = null;
        this.fatorDomingos = null;
        this.fatorFeriados = null;
        this.fatorFolgas = null;
    }    
}